import type { AdsCapabilityResponse } from '@web-platform/shared-universal-types/src/network/types';
import type {
  AdvertVisibleAction,
  CreativesQueryRequiredAction,
  CreativesLoadedAction,
  CreativesQueryErrorAction,
  CreativesQueryInFlightAction,
  CreativesQueryTimedOutAction,
} from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';

export const ADVERT_VISIBLE = 'ADVERT_VISIBLE';
export const CREATIVES_LOADED = 'CREATIVES_LOADED';
export const CREATIVES_QUERY_REQUIRED = 'CREATIVES_QUERY_REQUIRED';
export const CREATIVES_QUERY_IN_FLIGHT = 'CREATIVES_QUERY_IN_FLIGHT';
export const CREATIVES_QUERY_ERROR = 'CREATIVES_QUERY_ERROR';
export const CREATIVES_QUERY_TIMED_OUT = 'CREATIVES_QUERY_TIMED_OUT';

export function advertVisible(): AdvertVisibleAction {
  return {
    type: ADVERT_VISIBLE,
  };
}

export function creativesLoaded(data: AdsCapabilityResponse): CreativesLoadedAction {
  return {
    type: CREATIVES_LOADED,
    data,
  };
}

export function creativesQueryRequired(): CreativesQueryRequiredAction {
  return {
    type: CREATIVES_QUERY_REQUIRED,
  };
}

export function creativesQueryInFlight(): CreativesQueryInFlightAction {
  return {
    type: CREATIVES_QUERY_IN_FLIGHT,
  };
}

export function creativesQueryError(): CreativesQueryErrorAction {
  return {
    type: CREATIVES_QUERY_ERROR,
  };
}

export function creativesQueryTimedOut(): CreativesQueryTimedOutAction {
  return {
    type: CREATIVES_QUERY_TIMED_OUT,
  };
}
